import { getOptions } from '../api'

export default {
    getCountries({ commit }) {
        let requestUrl = getOptions('countries')

        axios.get(requestUrl)
            .then(response => {
                commit('getCountries', response.data.countries)
            })
            .catch(error => {})
    },
}


// WEBPACK FOOTER //
// ./src/store/_actions.js